import type { CSSProperties } from 'react';

type PropsType = {
  overrideStyle?: CSSProperties;
};

const StoreIcon = ({ overrideStyle = {} }: PropsType) => (
  <svg viewBox="0 0 16 16" fill="none" style={overrideStyle}>
    <path
      d="M2 7.66675V13.3334C2 13.687 2.14048 14.0262 2.39052 14.2762C2.64057 14.5263 2.97971 14.6667 3.33333 14.6667H12.6667C13.0203 14.6667 13.3594 14.5263 13.6095 14.2762C13.8595 14.0262 14 13.687 14 13.3334V7.66675"
      stroke="#152934"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.3335 4.66659H14.6668L13.5849 1.96186C13.4331 1.5822 13.0654 1.33325 12.6565 1.33325H3.34386C2.93496 1.33325 2.56725 1.5822 2.41539 1.96186L1.3335 4.66659ZM1.3335 4.66659V5.77659C1.3335 7.0045 2.32892 7.99992 3.55683 7.99992C4.78474 7.99992 5.78016 7.0045 5.78016 5.77659M5.78016 4.66659V5.77659M5.78016 5.77659C5.78016 7.0045 6.77558 7.99992 8.0035 7.99992C9.23141 7.99992 10.2268 7.0045 10.2268 5.77659M10.2268 4.66659V5.77659M10.2268 5.77659C10.2268 7.0045 11.2222 7.99992 12.4502 7.99992C13.6781 7.99992 14.6735 7.0045 14.6735 5.77659V4.66659"
      stroke="#152934"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 14.6667V11C6 10.4477 6.44772 10 7 10H9C9.55228 10 10 10.4477 10 11V14.6667"
      stroke="#152934"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StoreIcon;
